import { createTheme } from "@mui/material/styles";
import { colors, radius, shadow } from "./tokens";

const Theme = createTheme({
  typography: {
    fontFamily: `'Inter', sans-serif`,
  },
  palette: {
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      dark: colors.primary.dark,
      contrastText: colors.primary.contrastText,
    },
    success: { main: colors.success.main },
    warning: { main: colors.warning.main },
    error: { main: colors.error.main },
    info: { main: colors.info.main },
    text: {
      primary: colors.body,
      secondary: colors.muted,
    },
  },
  shape: {
    borderRadius: 4, // MUI default; numeric `borderRadius` sx values multiply by this
  },
  // Custom token bag — read in components via useTheme(): theme.tokens.radius.card
  tokens: { colors, radius, shadow },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          // Square-ish buttons with a light bend, enforced project-wide
          // (!important overrides any inline sx borderRadius on individual buttons).
          borderRadius: "6px !important",
          fontWeight: 700,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#e0e0e0" },
            "&:hover fieldset": { borderColor: "#bdbdbd" },
            "&.Mui-focused fieldset": {
              borderColor: colors.primary.main,
            },
          },
        },
      },
    },
    // Project-wide tooltip design: blue bubble, white text, matching arrow.
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: colors.primary.main,
          color: "#ffffff",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: radius.sm,
          padding: "8px 12px",
          boxShadow: "0 4px 12px rgba(28,151,227,0.25)",
        },
        arrow: {
          color: colors.primary.main,
        },
      },
    },
  },
});

export default Theme;
